import apiClient from "./apiClient";

const BASE = "/api/v1";

export async function fetchWebhooks(params) {
  const { data } = await apiClient.get(`${BASE}/webhook-registry`, { params });
  return Array.isArray(data) ? data : [];
}

export async function fetchWebhookIntegrations() {
  const { data } = await apiClient.get(`${BASE}/webhook-registry/integrations`);
  return {
    auth_types: Array.isArray(data?.auth_types) ? data.auth_types : [],
    payload_transforms: Array.isArray(data?.payload_transforms)
      ? data.payload_transforms
      : []
  };
}

export async function createWebhook(payload) {
  return apiClient.post(`${BASE}/webhook-registry`, payload);
}

export async function patchWebhook(id, payload) {
  return apiClient.patch(`${BASE}/webhook-registry/${id}`, payload);
}

export async function deleteWebhook(id) {
  return apiClient.delete(`${BASE}/webhook-registry/${id}`);
}

export async function fetchNotificationSettings() {
  const { data } = await apiClient.get(`${BASE}/notification-settings`);
  return Array.isArray(data) ? data : [];
}

export async function createNotificationSetting(payload) {
  return apiClient.post(`${BASE}/notification-settings`, payload);
}

export async function patchNotificationSetting(id, payload) {
  return apiClient.patch(`${BASE}/notification-settings/${id}`, payload);
}

export async function deleteNotificationSetting(id) {
  return apiClient.delete(`${BASE}/notification-settings/${id}`);
}

export async function fetchLexAiEvents() {
  const { data } = await apiClient.get(`${BASE}/lexai/events`);
  return Array.isArray(data) ? data : [];
}

/**
 * Catalogued endpoints this org can route events to — every endpoint of every
 * API the org has an enabled integration for, in one call.
 *
 * Powers the Subscriptions tab's endpoint destination picker. Unlike a webhook
 * (a bare URL someone types in), an endpoint destination reuses the
 * integration's stored credentials, base URL, retries and execution logs.
 */
export async function fetchOrgEndpointCatalog() {
  const { data } = await apiClient.get(`${BASE}/org/provider-api-catalog`);
  return Array.isArray(data) ? data : [];
}

export async function enableLexAi(payload) {
  return apiClient.post(`${BASE}/lexai/enable`, payload);
}

export async function fetchLexAiLogs(params) {
  const { data } = await apiClient.get(`${BASE}/lexai/logs`, { params });
  return Array.isArray(data) ? data : [];
}

export async function testLexAiWebhook(payload) {
  return apiClient.post(`${BASE}/lexai/test-webhook`, payload);
}

export function getErrorDetail(error) {
  const d = error?.response?.data;
  if (Array.isArray(d?.detail)) {
    return d.detail
      .map((item) => item.msg || (typeof item === "string" ? item : JSON.stringify(item)))
      .join("; ");
  }
  if (d?.detail !== undefined) return String(d.detail);
  if (typeof d === "string") return d;
  if (error?.message) return error.message;
  return "Request failed";
}
